import { Action, createReducer, on } from '@ngrx/store';
import { fromResignEmployeeActions } from '../actions';

export const resignEmployeeFeatureKey = 'resignEmployee';

export interface ResignEmployeeState {
  loadResignEmployeeResponse: string;
  loadResignEmployeeFailure: Error | any;
}

export const initialState: ResignEmployeeState = {
  loadResignEmployeeResponse: undefined,
  loadResignEmployeeFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromResignEmployeeActions.resignEmployeeSuccess, (state, action) => ({
    ...state,
    loadResignEmployeeResponse: action.response
  })),
  on(fromResignEmployeeActions.resignEmployeeFailure, (state, action) => ({
    ...state,
    loadResignEmployeeFailure: action.error
  }))
);
